import axios from "axios";
import source from "./http/source";

class API {
  constructor() {
    this.name = "API";
    this.source = source;
    this.isFetching = false;
    this.token = localStorage.getItem('token');
    this.fetch = this.fetch.bind(this);
  }

  createCallUrl(requestedUrl) {
    const source = this.source.find((s) => s.route === requestedUrl);
    return source ? source.url : null;
  }
  // axios.post('https://web-project-july-2021.herokuapp.com/api/user/login',data,{
  //           withCredentials: true,
  //           credentials: 'include',
  //         })
//   headers: {
//     'Content-Type': 'multipart/form-data',
//     'Authorization': `Bearer ${}`
// }
  fetch(param) {
    let { url, method, data, type } = param;
    return new Promise((resolve, reject) => {
      (type === 'auth' || !this.token ) ?
      (
        axios({
          method: method,
          url: this.createCallUrl(url),
          data: data,
          withCredentials: true,
          credential:"include"
        })
          .then((response) => {
            this.isFetching = false;
            resolve(response.data);
          })
          .catch((err) => {
            this.isFetching = false;
            reject(err);
          })
      ) : (
        axios({
          method: method,
          url: this.createCallUrl(url),
          data: data,
          headers: {
            'Authorization': `Bearer ${this.token}`
          }
        })
          .then((response) => {
            this.isFetching = false;
            resolve(response.data);
          })
          .catch((err) => {
            this.isFetching = false;
            reject(err);
          })
      )
    });
  }
}

export default new API();
